import styled from 'styled-components';

export const SelectContainer = styled.div``;